import { styled } from '@material-ui/core';
import { TabPanel } from '@material-ui/lab';

export const StyledTabPanel = styled(TabPanel)({
  padding: 10,
  '&:not([hidden])': {
    padding: 10,
  },
});
